import { render, staticRenderFns } from "./InsolvencyPractitionersRegistry.vue?vue&type=template&id=3a13e090&scoped=true&"
import script from "./InsolvencyPractitionersRegistry.vue?vue&type=script&lang=js&"
export * from "./InsolvencyPractitionersRegistry.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyPractitionersRegistry.vue?vue&type=style&index=0&id=3a13e090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a13e090",
  null
  
)

export default component.exports